<script setup lang="ts">
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'

const doc_url = import.meta.env.VITE_APP_DOCUMENTATION_URL

function navigateToDoc() {
  const url = doc_url ? doc_url : '/docs/'
  window.open(url, '_blank')
}

const cards = [
  {
    name: 'John Doe',
    image: '/header_lazy.jpg',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
  }
]
</script>
<template>
  <div class="fill-height test">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <v-card-title class="title-text">Contact us & about the team</v-card-title>
      <v-spacer></v-spacer>
      <v-card-text class="body-text">
        <p style="margin-bottom: 16px">
          <span class="body-text"
            >For help with using Template App, please reach out to us via
          </span>
          <span class="text-primary">contact@haskoning.com</span>
        </p>
        <p style="margin-bottom: 16px">
          <span class="body-text">Please also review our </span>
          <span
            class="text-primary"
            @click="navigateToDoc"
            style="cursor: pointer; display: inline-flex; align-items: center"
          >
            Documentation section
            <span class="mdi mdi-open-in-new" style="margin-left: 3px"></span>
          </span>
          <span class="body-text"> for assistance</span>.
        </p>
      </v-card-text>

      <v-container fluid>
        <v-row justify="space-between" align="stretch">
          <v-col
            v-for="(card, index) in cards"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="team-col"
          >
            <v-card>
              <v-img
                position="top"
                class="align-end top-aligned-img"
                :src="card.image"
                height="200"
                gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.2)"
                cover
              >
                <v-card-title class="text-white">
                  {{ card.name }}
                </v-card-title>
              </v-img>

              <v-card-text class="body-text">{{ card.description }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </AppBackground>
  </div>
</template>

<style scoped>
.title-text,
.body-text,
.team-name {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
}

.title-text {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 10px;
}

.body-text,
.team-card,
.team-card .v-card-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.team-name {
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.mt-5 {
  margin-top: 40px;
}

.team-col {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.team-card {
  width: 350px;
  min-width: 350px;
  max-width: 350px;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 10px;
}

.team-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 220px;
  margin: 0 auto 16px auto;
  background: #f8f8f8;
  border-radius: 8px;
  overflow: hidden;
}

.team-image {
  width: 220px !important;
  height: 220px !important;
  border-radius: 8px;
  display: block;
}

.top-aligned-img >>> .v-img__img {
  background-position: top !important;
}

@media (max-width: 960px) {
  .team-col {
    margin-bottom: 16px;
  }
}
</style>
